import { fileOpenMethod } from '@convenia/helpers'

const getFileName = (name = '', extension) =>
  !name.includes('.') && extension
    ? name + '.' + extension
    : name

export const mapFiles = (files, params) => {
  const { employeeId, getFileUrl } = params || {}

  return (files || []).map(({ id, fileName, extension, size }) => ({
    id,
    size,
    url: () => getFileUrl(id, employeeId),
    name: getFileName(fileName, extension),
    preview: () => getFileUrl(id, employeeId),
    openMethod: fileOpenMethod,
  }))
}
